import { IconButton, Tooltip } from '@dev-spendesk/grapes';

import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { useAccountingSoftwareName } from 'src/core/modules/accounting-integration/apis';
import { type SyncMode } from 'src/core/modules/accounting-integration/apis/useSetSyncSettings';

type Props = {
  customFieldValueId: string;
  showUpdateCustomFieldValueModal: ({
    customFieldValueId,
    customFieldValueName,
  }: {
    customFieldValueId: string;
    customFieldValueName: string;
  }) => void;
  showDeleteCustomFieldValueModal: ({
    customFieldValueId,
    customFieldValueName,
  }: {
    customFieldValueId: string;
    customFieldValueName: string;
  }) => void;
  customFieldValueName: string;
  syncMode?: SyncMode;
};

export const CustomFieldRowActions = ({
  customFieldValueId,
  showUpdateCustomFieldValueModal,
  showDeleteCustomFieldValueModal,
  customFieldValueName,
  syncMode,
}: Props) => {
  const { t } = useTranslation('global');
  const { accountingSoftwareName } = useAccountingSoftwareName();

  return (
    <div className="flex gap-4">
      <IconButton
        variant="tertiaryNeutral"
        iconName="pen"
        onClick={() =>
          showUpdateCustomFieldValueModal({
            customFieldValueId,
            customFieldValueName,
          })
        }
        aria-label={t('misc.edit')}
      />
      {syncMode === 'pull' ? (
        <Tooltip
          content={t(
            'bookkeep.integrations.settings.analyticalFieldMapping.disableDeleteTooltip',
            { integration: accountingSoftwareName },
          )}
        >
          <IconButton
            variant="tertiaryNeutral"
            disabled={syncMode === 'pull'}
            iconName="trash"
            onClick={() =>
              showDeleteCustomFieldValueModal({
                customFieldValueId,
                customFieldValueName,
              })
            }
            aria-label={t('misc.delete')}
          />
        </Tooltip>
      ) : (
        <IconButton
          variant="tertiaryNeutral"
          iconName="trash"
          onClick={() =>
            showDeleteCustomFieldValueModal({
              customFieldValueId,
              customFieldValueName,
            })
          }
          aria-label={t('misc.delete')}
        />
      )}
    </div>
  );
};
